import React from "react";
import { Button, styled } from "@mui/material";

export interface ClearFilterProps {
  clearFilters: () => void;
  setClassName?: (className: string) => void;
  wasSearched: boolean;
}

const ButtonContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: 10,
}));

export const ClearFilter: React.FC<ClearFilterProps> = ({
  clearFilters,
  wasSearched,
  setClassName,
}: ClearFilterProps) => {
  return wasSearched ? (
    <ButtonContainer>
      <Button
        variant="outlined"
        onClick={() => {
          clearFilters();
          if (setClassName) {
            setClassName("");
          }
        }}
      >
        Clear filters
      </Button>
    </ButtonContainer>
  ) : (
    <></>
  );
};
